<template>
  <div>
    <v-img class="imgDiagram" :src="imagedata.path" contain :aspect-ratio="1.5">
      <template v-slot:placeholder>
        <v-layout>
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-layout>
      </template>
    </v-img>
    <p class="subtitletext" v-if="imagedata.description">{{ imagedata.description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    imagedata: Object
  }
}
</script>

<style scoped>
  .imgDiagram {
    margin-bottom: 1%;
  }

  .subtitletext {
    font-style: italic;
    margin: 5px 0px 15px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/documentation/PicturesSection.vue